import { Component, Input } from '@angular/core';
import { IconType } from '@ng-icons/core';

@Component({
  selector: 'app-status-card',
  templateUrl: './status-card.component.html',
  styleUrl: './status-card.component.css'
})
export class StatusCardComponent {
  @Input() public title: string;
  @Input() public count: string;
  @Input() public iconName: IconType;
  @Input() public iconColor: string;
  @Input() public iconBoxColor: string;
}
